import { getLegacyBoilerName, notAvailableOTFlags } from '../../utils/open-therm';
import { createSelector } from '@reduxjs/toolkit';
export function getBoilerStateText(is_fail, is_working, cascade_state) {
    if (is_fail) {
        return 'Авария';
    }
    if (cascade_state === 'reserve') {
        return 'Резерв';
    }
    if (cascade_state === 'reserve_on') {
        return 'Резерв (включен)';
    }
    if (cascade_state === 'on' || is_working) {
        return 'Включен';
    }
    return 'По запросу';
}
const id_regex = new RegExp(/(\d)\.(\d)/);
export function getLegacyBoilerOTState(id, last_boiler_state, otzones_last) {
    //1 АЦШ
    if (last_boiler_state?.ot) {
        return last_boiler_state?.ot;
    }
    let _id = id;
    // need for don't intersect sensors see getLegacyOpenThermThermometer
    const matches = id.toString().match(id_regex);
    if (matches) {
        _id = Number(matches[1]);
    }
    //> 1 АЦШ
    return otzones_last?.[_id - 1];
}
function getLegacyBoilerHeatingCircuitConfig(ot_save_params, ot_boiler_type, index, is_relay, name = index === 1 ? `Котел` : `Котел ${index}`) {
    const id = index;
    const not_available_ot_flags = notAvailableOTFlags(ot_save_params);
    const boiler_model = ot_boiler_type;
    return {
        id,
        name,
        boiler_model,
        is_hidden: false,
        not_available_ot_flags,
        is_relay,
    };
}
export const getLegacyBoilerHeatingCircuits = createSelector((device) => device.ot_zones_count, (device) => device.ot_enabled, (device) => device.thermostat_zones_settings, (device) => device.ot_save_params, (device) => device.ot_boiler_type, (ot_zones_count, ot_enabled, thermostat_zones_settings, ot_save_params, ot_boiler_type) => {
    //1 АЦШ
    if (!ot_zones_count && ot_enabled) {
        const name = getLegacyBoilerName(thermostat_zones_settings, 1);
        return getLegacyBoilerHeatingCircuitConfig(ot_save_params, ot_boiler_type, 1, false, name);
    }
    const boilers = Object.entries(thermostat_zones_settings ?? {}).filter(([, { flags }]) => flags.includes('boiler'));
    let output_boilers = [];
    // > 1 АЦШ
    if (ot_enabled) {
        const shared_boiler_heating_circuits = Array(ot_zones_count)
            .fill(null)
            .map((_zone, index) => {
            const id = Number(index + 1);
            const name = getLegacyBoilerName(thermostat_zones_settings, id);
            return getLegacyBoilerHeatingCircuitConfig(ot_save_params, ot_boiler_type, id, false, name);
        });
        output_boilers = shared_boiler_heating_circuits;
        // return shared_boiler_heating_circuits;
    }
    const relay_boilers = boilers.slice(ot_zones_count).map(([id]) => {
        const _id = Number(id);
        return {
            id: _id,
            name: getLegacyBoilerName(thermostat_zones_settings, _id),
            is_hidden: false,
            is_relay: true,
        };
    });
    if (relay_boilers.length > 0) {
        output_boilers = [...output_boilers, ...relay_boilers];
    }
    return output_boilers;
});
